export default __webpack_public_path__ + "static/media/numbersinput_locked_crown.3f5d5969.svg";